const e = "Druk op Enter om te Bewerken", t = {
  pressEnterToEdit: e
};
export {
  t as default,
  e as pressEnterToEdit
};
